import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as serverDownMessages from "../stringFiles/serverDown.json";
@Component({
  selector: 'app-server-down',
  templateUrl: './server-down.component.html',
  styleUrl: './server-down.component.css'
})
export class ServerDownComponent implements OnInit {
  constructor(private router: Router,) { }

  errorDetails: string = "";
  strings: any = serverDownMessages;
  ngOnInit(): void {
    this.errorDetails = localStorage.getItem("serverDown")

    if (!this.errorDetails) {
      this.router.navigate(["/dashboard"]);
    }

  }
  handleDashboard() {
    this.router.navigate(["/dashboard"]);
  }
}